export default "__VITE_ASSET__BnqukSUZ__"